import { __assign, __extends } from "tslib";
import { SENSITIVE_STRING } from "@aws-sdk/smithy-client";
import { GlueServiceException as __BaseException } from "./GlueServiceException";
var ConcurrentRunsExceededException = (function (_super) {
    __extends(ConcurrentRunsExceededException, _super);
    function ConcurrentRunsExceededException(opts) {
        var _this = _super.call(this, __assign({ name: "ConcurrentRunsExceededException", $fault: "client" }, opts)) || this;
        _this.name = "ConcurrentRunsExceededException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, ConcurrentRunsExceededException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return ConcurrentRunsExceededException;
}(__BaseException));
export { ConcurrentRunsExceededException };
var IllegalWorkflowStateException = (function (_super) {
    __extends(IllegalWorkflowStateException, _super);
    function IllegalWorkflowStateException(opts) {
        var _this = _super.call(this, __assign({ name: "IllegalWorkflowStateException", $fault: "client" }, opts)) || this;
        _this.name = "IllegalWorkflowStateException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, IllegalWorkflowStateException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return IllegalWorkflowStateException;
}(__BaseException));
export { IllegalWorkflowStateException };
export var Comparator;
(function (Comparator) {
    Comparator["EQUALS"] = "EQUALS";
    Comparator["GREATER_THAN"] = "GREATER_THAN";
    Comparator["GREATER_THAN_EQUALS"] = "GREATER_THAN_EQUALS";
    Comparator["LESS_THAN"] = "LESS_THAN";
    Comparator["LESS_THAN_EQUALS"] = "LESS_THAN_EQUALS";
})(Comparator || (Comparator = {}));
export var Sort;
(function (Sort) {
    Sort["ASCENDING"] = "ASC";
    Sort["DESCENDING"] = "DESC";
})(Sort || (Sort = {}));
var IllegalBlueprintStateException = (function (_super) {
    __extends(IllegalBlueprintStateException, _super);
    function IllegalBlueprintStateException(opts) {
        var _this = _super.call(this, __assign({ name: "IllegalBlueprintStateException", $fault: "client" }, opts)) || this;
        _this.name = "IllegalBlueprintStateException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, IllegalBlueprintStateException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return IllegalBlueprintStateException;
}(__BaseException));
export { IllegalBlueprintStateException };
var NoScheduleException = (function (_super) {
    __extends(NoScheduleException, _super);
    function NoScheduleException(opts) {
        var _this = _super.call(this, __assign({ name: "NoScheduleException", $fault: "client" }, opts)) || this;
        _this.name = "NoScheduleException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, NoScheduleException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return NoScheduleException;
}(__BaseException));
export { NoScheduleException };
var SchedulerRunningException = (function (_super) {
    __extends(SchedulerRunningException, _super);
    function SchedulerRunningException(opts) {
        var _this = _super.call(this, __assign({ name: "SchedulerRunningException", $fault: "client" }, opts)) || this;
        _this.name = "SchedulerRunningException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, SchedulerRunningException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return SchedulerRunningException;
}(__BaseException));
export { SchedulerRunningException };
var MLTransformNotReadyException = (function (_super) {
    __extends(MLTransformNotReadyException, _super);
    function MLTransformNotReadyException(opts) {
        var _this = _super.call(this, __assign({ name: "MLTransformNotReadyException", $fault: "client" }, opts)) || this;
        _this.name = "MLTransformNotReadyException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, MLTransformNotReadyException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return MLTransformNotReadyException;
}(__BaseException));
export { MLTransformNotReadyException };
var CrawlerNotRunningException = (function (_super) {
    __extends(CrawlerNotRunningException, _super);
    function CrawlerNotRunningException(opts) {
        var _this = _super.call(this, __assign({ name: "CrawlerNotRunningException", $fault: "client" }, opts)) || this;
        _this.name = "CrawlerNotRunningException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, CrawlerNotRunningException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return CrawlerNotRunningException;
}(__BaseException));
export { CrawlerNotRunningException };
var CrawlerStoppingException = (function (_super) {
    __extends(CrawlerStoppingException, _super);
    function CrawlerStoppingException(opts) {
        var _this = _super.call(this, __assign({ name: "CrawlerStoppingException", $fault: "client" }, opts)) || this;
        _this.name = "CrawlerStoppingException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, CrawlerStoppingException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return CrawlerStoppingException;
}(__BaseException));
export { CrawlerStoppingException };
var SchedulerNotRunningException = (function (_super) {
    __extends(SchedulerNotRunningException, _super);
    function SchedulerNotRunningException(opts) {
        var _this = _super.call(this, __assign({ name: "SchedulerNotRunningException", $fault: "client" }, opts)) || this;
        _this.name = "SchedulerNotRunningException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, SchedulerNotRunningException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return SchedulerNotRunningException;
}(__BaseException));
export { SchedulerNotRunningException };
var VersionMismatchException = (function (_super) {
    __extends(VersionMismatchException, _super);
    function VersionMismatchException(opts) {
        var _this = _super.call(this, __assign({ name: "VersionMismatchException", $fault: "client" }, opts)) || this;
        _this.name = "VersionMismatchException";
        _this.$fault = "client";
        Object.setPrototypeOf(_this, VersionMismatchException.prototype);
        _this.Message = opts.Message;
        return _this;
    }
    return VersionMismatchException;
}(__BaseException));
export { VersionMismatchException };
export var QuerySchemaVersionMetadataResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RegisterSchemaVersionInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RegisterSchemaVersionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RemoveSchemaVersionMetadataInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RemoveSchemaVersionMetadataResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ResetJobBookmarkRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ResetJobBookmarkResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ResumeWorkflowRunRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ResumeWorkflowRunResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RunStatementRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var RunStatementResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var PropertyPredicateFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SortCriterionFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SearchTablesRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var SearchTablesResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartBlueprintRunRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartBlueprintRunResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartCrawlerRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartCrawlerResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartCrawlerScheduleRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartCrawlerScheduleResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartExportLabelsTaskRunRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartExportLabelsTaskRunResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartImportLabelsTaskRunRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartImportLabelsTaskRunResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartJobRunRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartJobRunResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartMLEvaluationTaskRunRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartMLEvaluationTaskRunResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartMLLabelingSetGenerationTaskRunRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartMLLabelingSetGenerationTaskRunResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartTriggerRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartTriggerResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartWorkflowRunRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StartWorkflowRunResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StopCrawlerRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StopCrawlerResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StopCrawlerScheduleRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StopCrawlerScheduleResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StopSessionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StopSessionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StopTriggerRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StopTriggerResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StopWorkflowRunRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var StopWorkflowRunResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TagResourceRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TagResourceResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UntagResourceRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UntagResourceResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateBlueprintRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateBlueprintResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateCsvClassifierRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateGrokClassifierRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateJsonClassifierRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateXMLClassifierRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateClassifierRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateClassifierResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateColumnStatisticsForPartitionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ColumnStatisticsErrorFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateColumnStatisticsForPartitionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateColumnStatisticsForTableRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateColumnStatisticsForTableResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateConnectionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateConnectionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateCrawlerRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateCrawlerResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateCrawlerScheduleRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateCrawlerScheduleResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateDatabaseRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateDatabaseResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var DevEndpointCustomLibrariesFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateDevEndpointRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateDevEndpointResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateJobResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateMLTransformRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateMLTransformResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdatePartitionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdatePartitionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateRegistryInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateRegistryResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateSchemaInputFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateSchemaResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateTableRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateTableResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var TriggerUpdateFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateTriggerRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateTriggerResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateUserDefinedFunctionRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateUserDefinedFunctionResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateWorkflowRequestFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var UpdateWorkflowResponseFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var MappingFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var ApplyMappingFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CodeGenConfigurationNodeFilterSensitiveLog = function (obj) { return (__assign({}, obj)); };
export var CreateJobRequestFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.CodeGenConfigurationNodes && { CodeGenConfigurationNodes: SENSITIVE_STRING }))); };
export var JobFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.CodeGenConfigurationNodes && { CodeGenConfigurationNodes: SENSITIVE_STRING }))); };
export var JobUpdateFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.CodeGenConfigurationNodes && { CodeGenConfigurationNodes: SENSITIVE_STRING }))); };
export var GetJobResponseFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Job && { Job: JobFilterSensitiveLog(obj.Job) }))); };
export var UpdateJobRequestFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.JobUpdate && { JobUpdate: JobUpdateFilterSensitiveLog(obj.JobUpdate) }))); };
export var BatchGetJobsResponseFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Jobs && { Jobs: obj.Jobs.map(function (item) { return JobFilterSensitiveLog(item); }) }))); };
export var GetJobsResponseFilterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Jobs && { Jobs: obj.Jobs.map(function (item) { return JobFilterSensitiveLog(item); }) }))); };
